import React, { useEffect, useLayoutEffect, useState } from "react";
import styles from "./SocialFeed.module.scss";
import NewPostSocialFeed from "../../components/NewPostSocialFeed/NewPostSocialFeed";
import TrendingJobs from "../../components/TrendingJobs/TrendingJobs";
import { useDispatch, useSelector } from "react-redux";
import { getAllPosts } from "../../reducer/postsSlice";
import {
  followUser,
  getUserProfile,
  resetOtherUserProfile,
  unfollowUser,
} from "../../reducer/profileSlice";
import {
  getShowNotifier,
  removeTokens,
  serverFiles,
  setShowNotifier,
} from "../../utils/utils";
import toast from "../../components/Toast/toast";
import SocialPostComponent from "components/SocialPostComponent/SocialPostComponent";
import InfiniteScroll from "react-infinite-scroll-component";
// import CustomSortDropdown from "components/CustomSortDropdown/CustomSortDropdown";
import SocialPostSkeleton from "components/SocialPostComponent/SocialPostSkeleton";
import Button from "components/UI/Button/Button";
import FilterIconSVG from "components/SVGComponents/FilterIconSVG";
import PlusIconSVG from "components/SVGComponents/PlusIconSVG";
import Modal from "components/Modal/Modal";
import useDisclosure from "../../hooks/useDisclosure";
import CheckTickSvg from "components/SVGComponents/CheckTickSvg";
import CrossIconSVG from "components/SVGComponents/CrossIconSVG";
import { differenceInCalendarDays, format, parseISO } from "date-fns";
import { Link, useLocation, useNavigate } from "react-router-dom";
import NO_IMAGE from "../../images/NO_IMAGE.jpg";
import Tooltip from "components/common/Tooltip/Tooltip";
import CopyTextSVG from "../../components/SVGComponents/CopyTextSVG";
import SkillsCardComponent from "components/UserProfile/SkillsCardsComponent/SkillsCardComponent";
import FollowersList from "components/Followers/FollowersList/FollowersList";
import Suitcase from "components/SVGComponents/Suitcase";
import Select from "react-select";
import GlobalSearch from "components/UI/GlobalSearch/GlobalSearch";
import NewPostSocialFeedForModal from "components/NewPostSocialFeed/NewPostSocialFeedForModal";
import TermsConditions from "components/termsConditions/TermsConditions";
import CommunityGuideline from "components/CommunityGuidelines/CommunityGuideline";
import SpinnerLoader from "components/UI/SpinnerLoader/SpinnerLoader";
import noApplicationsImg from "../../images/errorImages/noApplications.png";
import NoImageSVG from "components/SVGComponents/NoImageSVG";
const sortOptions = [
  { label: "Latest", value: "latest" },
  { label: "Trending", value: "trending" },
  { label: "Following", value: "following" },
  // { label: "Oldest", value: "oldest" },
  // { label: "Recommendations", value: "recommendations" },
  // { label: "Ideas", value: "ideas" },
];
const tagsArray = ["ALL", "ADVICE", "THOUGHTS", "NETWORK"];

const leftLinks = [
  { path: "/about-us", name: "About" },
  { path: "/contact-us", name: "Contact Us" },
];

const customStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "transparent",
    border: "none",
    boxShadow: "none",
    minHeight: "auto",
    cursor: "pointer",
    padding: "0 0.2rem",
    // marginRight: "1rem",
    fontSize: "0.9rem",
    width: "6rem !important",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#6570fc",
    fontWeight: 600,
    fontSize: "0.9rem",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: "#6c63ff",
    padding: 0,
    transition: "transform 0.3s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "#fff",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    borderRadius: "6px",
    marginTop: "8px",
    padding: "4px 0",
    width: "6rem",
  }),
  option: (base, state) => ({
    ...base,
    color: "#6570fc",
    backgroundColor: state.isFocused
      ? "rgba(108, 99, 255, 0.1)"
      : "transparent",
    padding: "8px 12px",
    fontSize: "0.9rem",
    cursor: "pointer",
    fontWeight: state.isSelected ? "bold" : "normal",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: 0,
    fontSize: "0.9rem",
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
  }),
};

const SocialFeed = () => {
  const { userProfile, isProfileLoading } = useSelector(
    (state) => state.userProfile,
  );
  const { posts } = useSelector((state) => state.posts);
  const { activePlan } = useSelector((state) => state.payment);

  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [tag, setTag] = useState("ALL");
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState(sortOptions[0].label);
  const [daysRemaining, setDaysRemaining] = useState(10);
  const [showNotice, setShowNotice] = useState(false);
  const [followModal, setFollowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [termsModal, setTermsModal] = useState(false);
  const [guideLineModal, setGuideLineModal] = useState(false);

  const endDate = activePlan?.endDate ?? "";
  const formattedEndDate =
    format(new Date(activePlan?.endDate ?? null), "MMM dd, yyyy") || "N/A";
  const isSubscriptionQueued = activePlan?.queuedSubscription;
  const profileData = userProfile;
  // const profileImage = localStorage.getItem("profileImage");
  const imageSrc =
    profileData?.userType === "BUSINESS"
      ? serverFiles(profileData?.profileUrl)
      : serverFiles(profileData?.profileUrl);

  const {
    isOpen: newPostMobileModal,
    open: OpenNewPostMobileModal,
    close: CloseNewPostMobileModal,
    toggle: togglPostMobileModal,
  } = useDisclosure();

  const {
    isOpen: isSortModalOpen,
    open: openSortModal,
    close: closeSortModal,
  } = useDisclosure();

  const itemsPerPage = 5;

  const {
    isOpen: newPostModal,
    open: openNewPostModal,
    close: closeNewPostModal,
  } = useDisclosure(false);

  const fetchPosts = async ({ reset = false, tagOverride = null }) => {
    const currentPage = reset ? 1 : page;
    // const activeTag = tagOverride || tag;

    if (reset) {
      setIsLoading(true);
      setHasMore(true);
    }

    const params = {
      pageNo: currentPage,
      perPage: itemsPerPage,
      sortBy: sortBy.toLowerCase(),
    };

    if (tag !== "ALL") {
      params.tags = tag;
    }

    const res = hasMore && (await dispatch(getAllPosts(params)));

    if (res?.payload?.posts?.length < itemsPerPage) {
      setHasMore(false);
    }

    if (!reset) {
      setPage((prev) => prev + 1);
    } else {
      setPage(2);
    }

    setIsLoading(false);
  };

  const handleTagClick = (newTag) => {
    setTag(newTag.charAt(0).toUpperCase() + newTag.slice(1).toLowerCase());
    setPage(1);
    setHasMore(true);
  };

  const handleSortBy = (value) => {
    setSortBy(value);
    setPage(1);
    setHasMore(true);
    closeSortModal();
  };

  //To show the notifier only once to user
  const closeNotifier = () => {
    setShowNotice(false);
    setShowNotifier(true);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    dispatch(resetOtherUserProfile());
    setFollowModal(false);
  }, [pathname]);

  useEffect(() => {
    fetchPosts({ reset: true });
  }, [tag, sortBy]);

  useEffect(() => {
    const today = new Date();
    const parsedEndDate = parseISO(endDate);
    const days = differenceInCalendarDays(parsedEndDate, today);
    setDaysRemaining(days);
    let isUserNotified = getShowNotifier();
    if (daysRemaining <= 3 && daysRemaining >= 0 && !isUserNotified) {
      setShowNotice(true);
    }
  }, [endDate, daysRemaining]);

  if (isProfileLoading) {
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SpinnerLoader />
      </div>
    );
  }


  return (
    <section className={styles.socialFeed}>
      {/* PlanExpiration notifier text */}
      {userProfile?.userType === "BUSINESS" &&
        showNotice &&
        !isSubscriptionQueued && (
          <div className={styles.subscriptionNotifier}>
            {activePlan?.status === "Active" ? (
              daysRemaining > 0 ? (
                <p>
                  Your active plan will be ending within {daysRemaining}{" "}
                  {daysRemaining > 1 ? "days" : "day"}
                </p>
              ) : (
                <p>Your active plan will be ending today</p>
              )
            ) : daysRemaining > 0 ? (
              <p>
                Your active plan will be ending within {daysRemaining}{" "}
                {daysRemaining > 1 ? "days" : "day"}
              </p>
            ) : (
              <p>Your active plan will be ending today</p>
            )}
            <button onClick={closeNotifier}>
              <CrossIconSVG color="#ffffff" />
            </button>
          </div>
        )}

      {/* Plan Queuing up notifier text */}
      {userProfile?.userType === "BUSINESS" &&
        showNotice &&
        isSubscriptionQueued && (
          <div
            style={{ backgroundColor: "#3CB371" }}
            className={styles.subscriptionNotifier}
          >
            {activePlan?.status === "Active" ? (
              daysRemaining > 0 ? (
                <p>
                  Your next plan will be applied up automatically after{" "}
                  {daysRemaining} {daysRemaining > 1 ? "days" : "day"}
                </p>
              ) : (
                <p>Your next plan will be applied up automatically by today</p>
              )
            ) : daysRemaining > 0 ? (
              <p>
                Your next plan will be applied up automatically after{" "}
                {daysRemaining} {daysRemaining > 1 ? "days" : "day"}
              </p>
            ) : (
              <p>Your next plan will be applied up automatically by today</p>
            )}
            <button onClick={closeNotifier}>
              <CrossIconSVG color="#ffffff" />
            </button>
          </div>
        )}

      <div className={styles.add_post_button} onClick={OpenNewPostMobileModal}>
        <PlusIconSVG height="32px" width="32px" />
      </div>

      <section className={styles.userProfile}>
        <section className={styles.user_profile_left}>
          <Link
            to={`/user-profile`}
            className={`unstyledLink ${styles.user_profile_details}`}
          >
            {/* {profileData?.userType === "BUSINESS" ? (
              <img
                className={styles.user_profile_image}
                src={serverFiles(profileData?.companyResponseDto?.logo)}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NO_IMAGE;
                }}
                alt=""
              />
            ) : (
              <img
                className={styles.user_profile_image}
                src={profileImage}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NO_IMAGE;
                }}
                alt=""
              />
            )} */}

            {imageSrc ? (
              <img
                className={styles.user_profile_image}
                src={imageSrc}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NO_IMAGE;
                }}
                alt=""
              />
            ) : (
              <div className={styles.user_profile_image}>
                <NoImageSVG type="profile" height="100%" width="100%" />
              </div>
            )}

            <div className={styles.user_profile_description}>
              {profileData?.userType === "CREATOR" && (
                <p className={styles.user_profile_username}>
                  {`${profileData?.firstName || ""} ${
                    profileData?.lastName || ""
                  }`}
                </p>
              )}

              {profileData?.userType === "BUSINESS" && (
                <div className={styles.business}>
                  <p className={styles.user_profile_username}>
                    {`${profileData?.companyResponseDto?.name || ""}`}
                  </p>
                  <Suitcase height="18" width="18" />
                </div>
              )}

              {profileData?.userType === "BUSINESS" && (
                <p className={styles.user_profile_education}>
                  {`Est. - ${
                    profileData?.companyResponseDto?.establishmentYear || ""
                  }`}
                </p>
              )}

              <div className={styles.user_profile_education}>
                {profileData?.industry?.length > 0 && (
                  <Tooltip
                    force={true}
                    place="bottom"
                    data={profileData?.industry?.map((pref) => pref).join(", ")}
                  >
                    {profileData?.industry[0]}
                  </Tooltip>
                )}
              </div>

              <div className={styles.user_profile_education}>
                {profileData?.cityName && profileData?.cityName}
              </div>

              {profileData?.status === "ACCEPT" && (
                <p className={styles.user_profile_email}>
                  <CopyTextSVG
                    text={profileData?.email}
                    success="Email Copied Successfully"
                    error="Cannot Copy Email ID"
                    height={16}
                    width={16}
                  />

                  {profileData?.email}
                </p>
              )}

              <Modal
                modalOpen={followModal}
                onClose={() => setFollowModal(false)}
                width="30rem"
              >
                <FollowersList
                  onClose={() => setFollowModal(false)}
                  modalType={modalType}
                  userId={
                    profileData?.userAliasId ||
                    profileData?.companyResponseDto?.companyAliasId
                  }
                />
              </Modal>
            </div>
          </Link>
          {/* {profileData?.userType === "CREATOR" && (
            <SkillsCardComponent skills={profileData?.skills || []} />
          )} */}

          <div className={styles.links}>
            {leftLinks?.map((link, index) => (
              <Link
                className={`unstyledLink ${styles.single_link}`}
                to={link?.path}
                key={index}
              >
                {link?.name}
              </Link>
            ))}
            <p
              onClick={() => setTermsModal((prev) => !prev)}
              className={`unstyledLink ${styles.single_link}`}
            >
              Terms & Privacy Policy
            </p>
            <p
              onClick={() => setGuideLineModal((prev) => !prev)}
              className={`unstyledLink ${styles.single_link}`}
            >
              Community guidelines
            </p>
          </div>
        </section>
      </section>

      <Modal
        // width="40rem"
        onClose={(e) => {
          // e.stopPropagation()
          setGuideLineModal(false);
        }}
        heading="Community guidelines"
        modalOpen={guideLineModal}
        showCrossIcon={true}
      >
        <CommunityGuideline />
      </Modal>
      <Modal
        // width="40rem"
        onClose={(e) => {
          // e.stopPropagation()
          setTermsModal(false);
        }}
        heading="Terms & Conditions"
        modalOpen={termsModal}
        showCrossIcon={true}
      >
        <TermsConditions />
      </Modal>

      <section className={styles.left}>
        <NewPostSocialFeed containerClassName={styles.feedNewPost} />
        {pathname === "/feed" && (
          <GlobalSearch className={styles.searchContainer} />
        )}

        <section className={styles.tags_filter}>
          {/* <Button
            variant="outlined"
            className={styles.sort_filter_button}
            onClick={openSortModal}
          >
            <FilterIconSVG height="16px" width="16px" />
          </Button> */}
          <div className={styles.horizontal_separator}></div>
          {tagsArray?.map((item) => (
            <div
              key={item}
              onClick={() => handleTagClick(item)}
              className={`${styles.single_tag} ${
                tag.toUpperCase() === item ? styles.selected_tag : ""
              }`}
            >
              {item.charAt(0) + item.slice(1).toLowerCase()}
            </div>
          ))}
        </section>

        <section className={styles.socialFeedSeperator}>
          <div className={styles.seperator} />

          <span
            className={styles.sorter}
            // onClick={openSortModal}
          >
            <p>
              Sort By :
              {/* <span className={styles.sortBy_btn}>{sortBy}</span> */}
            </p>
            <Select
              options={sortOptions}
              styles={customStyles}
              defaultValue={sortOptions[0]}
              isSearchable={false}
              onChange={(selectedOption) => {
                // console.log('selectedOption', selectedOption)
                handleSortBy(selectedOption.label);
              }}
            />
          </span>
          <div className={styles.seperator} />
        </section>

        <section className={styles.social_posts_section}>
          {isLoading ? (
            <section className={styles.loading_position}>
              <SocialPostSkeleton count={5} />
            </section>
          ) : posts?.length > 0 ? (
            <InfiniteScroll
              dataLength={posts?.length}
              next={() => fetchPosts(false)}
              hasMore={hasMore}
              loader={
                <section className={styles.loading_position}>
                  <SocialPostSkeleton count={2} />
                </section>
              }
              // scrollableTarget="scrollableSection"
              scrollThreshold={0.9}
              className={styles.post_array}
              // endMessage={
              //   <p style={{ textAlign: "left", marginTop: "1rem" }}>
              //     <b>No more post</b>
              //   </p>
              // }
            >
              {posts?.map((post, index) => (
                <SocialPostComponent key={index} post={post} />
              ))}
            </InfiniteScroll>
          ) : (
            <div className={styles.no_jobs}>
              <img
                src={noApplicationsImg}
                alt=""
                className={styles.noApplicationsImg}
              />
              <p className={styles.noApplications_text}>No posts yet</p>
            </div>
          )}
        </section>
      </section>
      <section className={styles.right}>
        {/* <UserDetailsSocialFeed /> */}

        <div className={styles.sticky_rightSection}>
          <TrendingJobs />
        </div>
      </section>

      {/* <Modal
        background="white"
        modalOpen={isSortModalOpen}
        onClose={closeSortModal}
        width="20rem"
        drawer={{
          isDrawer: true,
        }}
      >
        <div className={styles.sort_filter}>
          <p>Sort By</p>

          <ul className={styles.filter_list}>
            {sortOptions?.map((option, index) => (
              <li key={index} onClick={() => handleSortBy(option.label)}>
                <span
                  className={`${
                    option.label === sortBy ? styles.selected : ""
                  }`}
                >
                  {option.label}
                </span>
                {option.label === sortBy && <CheckTickSvg />}
              </li>
            ))}
          </ul>
        </div>
      </Modal> */}

      {!newPostMobileModal && (
        <Modal
          background="white"
          modalOpen={newPostModal}
          shadowClassName={styles.postModalShadow}
          wrapperClassName={styles.postModalWrapper}
          bodyClassName={styles.postModalBody}
          onClose={closeNewPostModal}
          drawer={{
            isDrawer: true,
            heading: "New Post",
            isCloseIcon: true,
          }}
        >
          <NewPostSocialFeed key="mobile new modal" />
        </Modal>
      )}

      {newPostMobileModal && (
        <Modal
          background="white"
          modalOpen={newPostMobileModal}
          onClose={() => togglPostMobileModal()}
        >
          <NewPostSocialFeedForModal onClose={() => togglPostMobileModal()} />
        </Modal>
      )}
    </section>
  );
};

export default SocialFeed;
